
<section
  id="register"
  class="l-register"
>
  <div class="o-container">
    <h2 class="l-register__title">
      primeiro, o cadastro
    </h2>

    <p class="l-register__description">
      você vai precisar de um

      <span v-if="showRegisterLink">
        <a
          :href="userRegisterPath"
        > cadastro </a></span>

      <span v-else> cadastro </span>
      provando que não é um robô viciado em compras.
    </p>

    <div class="o-grid -xs-middle -xs-full -xs-between">
      <div class="o-grid__item l-register__wrapper -xs-24 -md-11">
        <img
          class="l-register__image"
          :src="`${require('@@/assets/images/landing-pages/how-to-buy/register/brands.png')}`"
          alt="Imagem reunindo em círculos as logos de diversas marcas encontradas no enjoei."
        >
      </div>

      <div class="o-grid__item l-register__grid -xs-24 -md-13">
        <div class="l-register__content">
          <h2 class="title l-register__content-title">
            mais de cinco milhões <span class="t-xs-block t-md-inline">de enjoos</span>
          </h2>

          <p class="l-register__content-description">
            navegue pela nossa página, veja marcas como adidas, apple, farm,
            melissa, schutz, zara com ofertas e promoções especialíssimas no
            nosso app.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
